import React from 'react';
import { Badge as ChakraBadge, BadgeProps as ChakraBadgeProps } from '@chakra-ui/react';

export default function Badge(props: ChakraBadgeProps) {
  return <ChakraBadge {...props} />;
}
